import { render, staticRenderFns } from "./ClosuresList.vue?vue&type=template&id=449a21ac&scoped=true&"
import script from "./ClosuresList.vue?vue&type=script&lang=ts&"
export * from "./ClosuresList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449a21ac",
  null
  
)

export default component.exports